/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import DTOExpiredInsuranceViewModal from './DTOExpiredInsuranceViewModal';
import ExpiredInsuranceViewModalPresenter from './ExpiredInsuranceViewModalPresenter';

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  expiredData: any;
  trans?: any;
}

const ExpiredInsuranceViewModalController = ({
  isModalOpen,
  closeModal,
  expiredData,
  trans,
}: ModalInterface) => {
  return (
    <>
      <DTOExpiredInsuranceViewModal />

      <ExpiredInsuranceViewModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        expiredInsuranceViewData={expiredData}
        trans={trans}
      />
    </>
  );
};

export default ExpiredInsuranceViewModalController;
